export default __webpack_public_path__ + "static/toyota-d7c1ff82da7929feeb9034352545cb6e.webm";